import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { parsePrice } from '../../../../../../../lib/helper.js';
import defaultMsg from '../../../../../../../translations/lang/en-US.json';

class OrderHistoryBody extends PureComponent {
  render() {
    const { discountDetails } = this.props;
    return (
      <li>
        <FormattedMessage id="discount" defaultMessage={defaultMsg.discount} /> -{' '}
        {discountDetails.title}
        <span className="pull-right">
          {'-' + parsePrice(discountDetails.discount_value)}
        </span>
      </li>
    );
  }
}

export default OrderHistoryBody;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/ReceiptDetails/SubTotal/Discount.jsx